const { request } = require('./request');
const baseURL = "/api/users";

export const login = (username, password) => {
    return request(`${baseURL}/login`, {
        method: 'POST',
        json: { username, password }
    });
};

export const register = (email, password, name) => {
    return request(baseURL, {
        method: 'POST',
        json: { email, password, name }
    });
};

export const getUserInfo = () => {
    return request(`${baseURL}/me`);
};

export const requestPasswordReset = (email) => {
    return request(`${baseURL}/reset-request`, {
        method: 'POST',
        json: {
          email
        }
    });
}

export const resetPassword = (token, password) => {
    return request(`${baseURL}/reset-password`, {
        method: 'POST',
        json: {
          password
        },
        token,
    });
}

export const updateProfile = (data) => {
  // { name: 'name', password: 'password' }
    return request(`${baseURL}/me`, {
        method: 'PUT',
        json: data,
    });
}

export const deleteAccount = () => {
    return request(`${baseURL}/me`, {
        method: 'DELETE',
    });
}

export const getUsage = () => {
    return request(`${baseURL}/me/usage`, {
        method: 'GET',
    });
}

/**
 * Get user subscription information including limits and plan details
 * @returns {Promise<Object>} User subscription data
 * @throws {Error} When request fails or user is unauthorized
 * 
 * @example
 * // Usage
 * try {
 *   const subscription = await getSubscription();
 *   console.log(subscription.tier); // 'free'
 *   console.log(subscription.totalEventLimit); // 30000
 *   console.log(subscription.hourlyEventLimit); // 120
 * } catch (error) {
 *   console.error('Failed to fetch subscription:', error);
 * }
 * 
 * @example
 * // Response structure
 * {
 *   "_id": "6845f1a8924733fcbd493762",
 *   "owner": "6845f1a8924733fcbd49375f",
 *   "tier": "free",                    // Plan tier: 'free', 'light', 'plus'
 *   "canExport": false,                // Export permission
 *   "apiAccess": false,                // API access permission
 *   "dataRetention": 1,                // Data retention in days
 *   "totalEventLimit": 30000,          // Monthly event limit
 *   "hourlyEventLimit": 120,           // Hourly event limit
 *   "deviceLimit": 3,                  // Maximum devices allowed
 *   "sourceLimit": 5,                  // Maximum sources allowed
 *   "smsLimit": 0,                     // SMS notifications limit
 *   "emailLimit": 25,                  // Email notifications limit
 *   "rulesLimit": 5,                   // Maximum rules allowed
 *   "overLimit": false,                // Whether user is over limits
 *   "startDate": "2025-06-08T20:25:12.569Z",
 *   "createdAt": "2025-06-08T20:25:12.569Z",
 *   "updatedAt": "2025-06-09T01:03:50.959Z",
 *   "__v": 0
 * }
 */
export const getSubscription = () => {
    return request(`${baseURL}/me/subscription`, {
        method: 'GET',
    });
}

export const cancelSubscription = () => {
    return request(`${baseURL}/me/subscription/cancel`, {
        method: 'DELETE',
    });
}

export const createCheckoutSession = () => {
    return request(`/api/checkout/create`, {
        method: 'POST',
    });
}

export const getCheckoutSession = (sessionId) => {
    return request(`/api/checkout?session_id=${sessionId}`, {
        method: 'GET',
    });
}

export const getBillingPortal = () => {
    return request(`/api/billing/portal`, {
        method: 'POST',
    });
}

export const getUsers = (page = 1, limit = 50, query = '') => {
    const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString()
    });
    
    if (query) {
        params.append('query', query);
    }
    
    return request(`/api/users?${params}`, {
        method: 'GET',
    });
}

export const impersonate = (userId) => {
    return request(`/api/users/${userId}/impersonate`, {
        method: 'POST',
    });
}
/**
 * Admin-only: grant or revoke premium for a user.
 * Toggling on moves the user to the light plan; toggling off reverts a comped
 * user to free. Rejects with status 409 when the user has an active paid
 * Stripe subscription (it must be cancelled in Stripe first).
 * @param {string} userId
 * @param {boolean} isPremium
 */
export const setPremium = (userId, isPremium) => {
    return request(`/api/users/${userId}/premium`, {
        method: 'PUT',
        json: { isPremium },
    });
}
